export const cohorte = [{option:'FT21A'},{option:'FT21B'},{option:'FT20A'},{option:'FT20B'},{option:'FT19A'},{option:'FT19B'},{option:'FT18A'},{option:'FT18B'},{option:'FT17A'},{option:'FT17B'},{option:'FT16A'},{option:'FT16B'}]


export const sortBy = [{option:'A-Z'},{option:'Z-A'}]